import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'

export default class extends BaseModule {
  init () {
    const colors = [
      '#FF0000',
      '#00FF00',
      '#0000FF',
      '#FFFF00',
      '#FF00FF',
      '#00FFFF'
    ]
    const flower = this.el.querySelector('.flower')

    gsap.to(flower, {
      rotate: '360',
      duration: 10,
      repeat: -1,
      ease: 'none',
      transformOrigin: 'center'
    })

    gsap.to(flower, {
      fill: colors[Math.floor(Math.random() * colors.length)],
      duration: 2,
      repeat: -1
    })
  }
}
